
import React, { useState } from 'react';
import { HexColorPicker } from "react-colorful";

const ColorPickerControl = ({ field,
    value,
    onChange,
    onBlur,
    className,
    disabled,
    loading,
    props,
    'aria-describedby': ariaDescribedBy,
}) => {

    const [selectedColor, setSelectedColor] = useState(value)
    let idLabel = "field_label_" + field.FieldName;
    const pickerId = "field_cpk_" + field.FieldName;
    const onChangeColor = (value, field) => {
        setSelectedColor(value);
        onChange({ target: { value } }, field);
    }

    // react-colorful's HexColorPicker renders a non-labelable custom widget
    // (not a native <input>/<select>), so <label htmlFor> cannot be used to
    // associate it directly per the HTML spec. Instead we group the visible
    // label and the picker with role="group"/aria-labelledby, which is the
    // standard ARIA fallback pattern for this kind of third-party control.
    // Note: role="group" does not support aria-invalid per the ARIA spec, so
    // only aria-describedby (a global attribute) is applied here; the error
    // text itself is still announced via the referenced role="alert" region.
    return (
        <div role="group" aria-labelledby={idLabel} aria-describedby={ariaDescribedBy}>
            <span {...(field.IsRequired && { required: true })} id={idLabel}>{field.DisplayName}</span>
            <HexColorPicker
                id={pickerId}
                name='color'
                color={value}
                onChange={(context) => onChangeColor(context, field)}
                {...props} />
            <div>{selectedColor}</div>
        </div>
    );
}

export default ColorPickerControl;